// **************************
// *** MeusAgendamentos (em aberto) abertos.jsx 
// *** autor: Walcledson de Paula
// *** MVinfo Sistemas & Automação
// *** 09/06/24
// *** 4/7/24 | 09h39 → acrescentado o token criptografado
// *** 14/11/24 | 13h54 → corrigido e melhorado a paginação em ambos os tipos de atendimento (tipoAtendimento = 0 ou 1)
// *** 15/11/24 | 16h24 → substituído o botão "excluir" pelo botão "opções" permitindo diversas ações pelo prestador
// *** 01/12/24 | 21h28 → acrescentado a opção de envio do formulário para o componente "p_cardagendamentoopcoes.jsx" prop: "paginaagendamento"
// *** 17/10/28 | 19h02 → acrescentado o campo "descrição" que faltava no Table. eliminamos todos as linhas comentadas não importantes
// **************************

import { useEffect, useState } from "react";
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import apiaxios from "../../../../Services/apiaxios.js";
import { decrypt } from "../../../../Services/cryptoUtils.js";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Dock } from 'react-dock'; // acrescentado para apresentar o menu "opções" de baixo pra cima 15/11/24w
import handleApiError from "../../../../Services/apiErrorHandler.js";
import { p_getUserData } from "../../../../Services/p_userutils.js";

import Menu from '../../Components/Menu/p_menu.jsx';
import { AutoLogout } from "../../../../Services/autologout.js";
import CardAgendamentos from '../../Components/Agendamentos/p_agendamentos.jsx';
import CardAgendamentoOpcoes from "../../Components/Agendamentos/p_cardagendamentoopcoes.jsx";
import Footer from "../../../AgendexCliente/components/Footer/footer.jsx";

import './p_agendamentos.css';

function MeusAgendamentos() {
    // verifica se os tokens estão corretos
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    const tokenLG = localStorage.getItem("tokenlg");
    // verifica se os tokens estão corretos
    useEffect(() => {
        if (!tokenASW || !tokenLG) {
            AutoLogout();
        }
    }, [tokenASW, tokenLG]);

    // se ajusta de acordo com o sistema (mobile, tablet, nb, pc, etc)
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    const initialUserData = p_getUserData();
    const [tipoAtendimento, setTipoAtendimento] = useState(initialUserData.tipoAtendimento); // 0 = não possui colaboradores, 1 = possui colaboradores
    const [id_usuario, setId_usuario] = useState(initialUserData.userId); // id_usuario logado 23/9/24w
    const [tamanho_pagina, setTamanho_pagina] = useState(initialUserData.TAMANHO_PAGINA); // id_usuario logado 23/9/24w
    const [nenhumAgendamentoEncontrado, setNenhumAgendamentoEncontrado] = useState(false);
    const [loading, setLoading] = useState(false);
    const [agendamentos, setAgendamentos] = useState([]);
    const [pagina, setPagina] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const MySwal = withReactContent(Swal);

    const [colaboradores, setColaboradores] = useState([]);
    const [colaborador, setColaborador] = useState(null);
    const [nenhumColaboradorEncontrado, setNenhumColaboradorEncontrado] = useState(false);

    const [dockOpen, setDockOpen] = useState(false); // Gerencia o estado do Dock
    // const [dockOperation, setDockOperation] = useState(""); // Gerencia a operação do Dock
    const openDock = () => setDockOpen(true);
    const closeDock = () => setDockOpen(false); // fechar o dock de dentro do componente p-cardservico.jsx
    const [selectedAgendamento, setSelectedAgendamento] = useState([]);

    useEffect(() => {
        setHasMore(true);
        const fetchAgendamentos = async () => {
            if (tipoAtendimento === 0) {
                // Chamada para agendamentos do tipo "Meus Agendamentos"
                await fetchAgendamentosAbertos(pagina);
            } else if (tipoAtendimento === 1 && colaborador) {
                // Chamada para agendamentos do colaborador selecionado
                await fetchAgendamentosPorColaborador(colaborador, pagina);
            }
        };
      
        fetchAgendamentos();
    }, [pagina, tipoAtendimento, colaborador]);

    // tipoAtendimento === 0 (busca agendamentos somente se não tiver colaboradores) 23/9/24w
    const fetchAgendamentosAbertos = async (pagina) => {
        setLoading(true);
        const url = `reserva/listarWeb?id_usuario=${id_usuario}&pagina=${pagina}&tamanho_pagina=
            ${tamanho_pagina}&id_status1=1&token=${tokenASW}`;
        try {
            const response = await apiaxios.get(url);

            if (response.data.retorno) {
                Swal.fire('Erro', 'Erro ao carregar agendamentos: ' + response.data.retorno, 'error');
            } else {
                if (response.data.length === 0) {
                    setNenhumAgendamentoEncontrado(true);
                    MySwal.fire({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                        icon: 'info',
                        title: 'Nenhum agendamento em aberto, encontrado neste momento...'
                    });
                    setHasMore(false);
                } else {
                    // console.log('response.data', response);
                    setNenhumAgendamentoEncontrado(false);
                    setAgendamentos(prevDados => [...prevDados, ...response.data]);
                    // console.log('response.data - abertos ', response.data);
                    if (response.data.length < tamanho_pagina) {
                        setHasMore(false);
                    }
                }
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    // tipoAtendimento === 1 (busca agendamentos dos colaboradores) 23/9/24w
    const fetchAgendamentosPorColaborador = async (id_colaborador, pagina) => {
        setLoading(true);
        // setAgendamentos([]);
        const url = `reserva/listarColaboradorWeb?
            id_usuario=${id_usuario}&pagina=${pagina}&tamanho_pagina=${tamanho_pagina}
            &id_status1=1&token=${tokenASW}&id_colaborador=${id_colaborador}`;
        try {
            const response = await apiaxios.get(url);

            if (response.data.retorno) {
                Swal.fire('Erro', 'Erro ao carregar agendamentos: ' + response.data.retorno, 'error');
            } else {
                if (response.data.length === 0) {
                    setNenhumAgendamentoEncontrado(true);
                    MySwal.fire({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                        icon: 'info',
                        title: 'Nenhum agendamento em aberto, encontrado neste momento...'
                    });
                    setHasMore(false);
                } else {
                    setNenhumAgendamentoEncontrado(false);
                    // console.log(`response data ao trocar colaborador: ${id_colaborador} `, response.data);
                    setAgendamentos(prevDados => [...prevDados, ...response.data]);
                    if (response.data.length < tamanho_pagina) {
                        setHasMore(false);
                    }
                }
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleOpcoes = (agendamento) => {
        // console.log('agendamento ', agendamento);
        // console.log('selectedAgendamento ', selectedAgendamento);
        // alert('teste de handleOpcoes');
        // setDockOperation("edit");
        setTimeout(() => {
            setSelectedAgendamento(agendamento);
            setDockOpen(true); // Abre o Dock
        }, 100);

    };

    useEffect(() => {
        const loadColaboradores = async () => {
            if (id_usuario) {
                try {
                    const empresaColaboradores = await fetchColaboradores(id_usuario);
                    setColaboradores(empresaColaboradores);
                } catch (error) {
                    console.error('Erro ao buscar colaboradores:', error);
                }
            }
        };

        loadColaboradores();

    }, [id_usuario]);
    
    const fetchColaboradores = async (id_empresa) => {
        try {
            setLoading(true);
            const colaboradoresResponse = await apiaxios.get(`/colaborador/listarWeb?id_empresa=${id_empresa}&id_usuario=${id_empresa}&token=${tokenASW}`);
            if (colaboradoresResponse.status === 200 && colaboradoresResponse.data.length > 0) {
                return colaboradoresResponse.data;
            } else {
                setNenhumColaboradorEncontrado(true);
                return [];
            }
        } catch (error) {
            handleApiError(error);
            return [];
        } finally {
            setLoading(false);
        }
    };




    return (
        <>
            <div className="topo-margin">
                <div className="container-fluid">
                    <div className="row flex-nowrap">
                        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                            <Menu page="agendamentosabertos" />
                        </div>
                        <div className="col py-2 me-3">
                            { tipoAtendimento === 0 ? (
                                <div className="container-fluid">
                                    <h1 className="text-center">Meus Agendamentos</h1>
                                    <div className="row">
                                        {loading && (
                                            <div className="loading-spinner-container">
                                                <Oval color="#00BFFF" height={80} width={80} />
                                            </div>
                                        )}
                                        {nenhumAgendamentoEncontrado ? (
                                            <div className="alert alert-danger mt-10" role="alert">
                                                Nenhum "Agendamento em Aberto" disponível neste momento...
                                            </div>
                                        ) : (
                                            <div className="box-agendamentos">
                                                <div className="table-responsive">  {/* ← ADICIONE AQUI */}
                                                    <table className="table">
                                                    {/* <table className="table table-striped"> */}
                                                    {/* <table className="table table-sm table-striped table-hover"> */}
                                                    {/* <table className="table table-striped table-bordered"> */}
                                                    {/* <table className="table table-sm"> */}
                                                        <thead>
                                                            <tr>
                                                                <th>Ida</th>
                                                                <th>Descrição</th>
                                                                <th>Nome Cliente</th>
                                                                {/* <th>Endereço Empresa</th> */}
                                                                <th>Fone Cliente</th>
                                                                <th>Data</th>
                                                                <th>Hora</th>
                                                                <th>Valor</th>
                                                                <th>Desconto</th>
                                                                <th>Vr Total</th>
                                                                <th>Obs</th>
                                                                <th className="text-right">Status</th>
                                                                <th className="text-right">Ações</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {/* {agendamentos.map(agendamento => ( */}
                                                            {/* {console.log('agendamentos dentro de p_abertos ', agendamentos)} */}
                                                            {agendamentos.map((agendamento, index) => (
                                                            <CardAgendamentos
                                                                    // key={agendamento.ID_RESERVA}
                                                                    key={`${agendamento.ID_RESERVA}-${index}`}
                                                                    agendamento={{
                                                                        agendamento_id: agendamento.ID_RESERVA,
                                                                        agendamento_descricao: agendamento.DESCRICAO || 'Descrição indisponível',
                                                                        // agendamento_nome: agendamento.NOME || 'Nome indisponível',
                                                                        // agendamento_fone: agendamento.FONE || 'Telefone indisponível',
                                                                        agendamento_nome: agendamento.AA_CLIENTE_NOME || 'Nome indisponível',
                                                                        agendamento_fone: agendamento.AA_CLIENTE_FONE || 'Telefone indisponível',
                                                                        agendamento_data: agendamento.DATA_RESERVA || 'Data indisponível',
                                                                        agendamento_hora: agendamento.HORA || 'Hora indisponível',
                                                                        agendamento_vr: agendamento.VALOR || 0, // Defina 0 ou um valor padrão para evitar undefined
                                                                        agendamento_desc: agendamento.DESCONTO || 0, // Defina 0 ou um valor padrão para evitar undefined
                                                                        agendamento_vrtot: agendamento.VALORTOTAL || 0, // Defina 0 ou um valor padrão para evitar undefined
                                                                        agendamento_obs: agendamento.AA_DESCRICAO || 'Obs indisp',
                                                                        agendamento_status: `${agendamento.ID_STATUS} : ${agendamento.ST_DESCRICAO || 'Status indisponível'}`
                                                                    }}
                                                                    showOpcoes={true}
                                                                    showExcluir={false}
                                                                    showAvaliar={false}
                                                                    showMotivo={false}
                                                                    showMudarStatus={false}
                                                                    // handleExcluir={handleExcluir}
                                                                    handleOpcoes={handleOpcoes}
                                                                />
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>  {/* ← ADICIONE AQUI */}
                                            </div>
                                        )}
                                    </div>
                                    {hasMore && (
                                        <div className="load-more">
                                            {/* <button onClick={() => setPagina(prevPagina => prevPagina + 1)}>Carregar mais</button> // modificado pela linha abaixo 14/11/24w 14h03 */} 
                                            <button onClick={() => setPagina((prevPagina) => prevPagina + 1)}>
                                                Carregar mais
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="form-group">
                                    <h1 className="text-center">Agendamentos Abertos por Colaborador</h1>
                                    <hr />
                                    <label htmlFor="colaborador">Selecione o Colaborador:</label>
                                    <select className="form-control" id="colaborador" 
                                        onChange={e => {
                                            const selectedColaborador = e.target.value;
                                            setColaborador(selectedColaborador);
                                            setPagina(1); // Reinicia a página para o valor inicial
                                            setAgendamentos([]);
                                        }} 
                                        value={colaborador || ''}
                                    >
                                        <option value="" disabled>Selecione...</option>
                                        {colaboradores.map(colab => (
                                            <option key={colab.COL_ID} value={colab.COL_ID}>
                                                {colab.COL_NOME}
                                            </option>
                                        ))}
                                    </select>

                                    <div className="row">
                                        {loading && (
                                            <div className="loading-spinner-container">
                                                <Oval color="#00BFFF" height={80} width={80} />
                                            </div>
                                        )}
                                        {nenhumAgendamentoEncontrado ? (
                                            <div className="alert alert-danger mt-10" role="alert">
                                                Nenhum "Agendamento em Aberto" disponível neste momento...
                                            </div>
                                        ) : (
                                            <div className="box-agendamentos">
                                                <div className="table-responsive">  {/*← ADICIONE AQUI */}
                                                {/* <div className="table-responsive">  ← ADICIONE AQUI */}
                                                    <table className="table">
                                                    {/* <table className="table table-striped"> */}
                                                    {/* <table className="table table-sm table-striped table-hover"> */}
                                                    {/* <table className="table table-striped table-bordered"> */}
                                                    {/* <table className="table table-sm"> */}
                                                        <thead>
                                                            <tr>
                                                                <th>Id</th>
                                                                <th>Descrição</th>
                                                                <th>Nome Cliente</th>
                                                                <th>Fone Cliente</th>
                                                                <th>Data</th>
                                                                <th>Hora</th>
                                                                <th>Valor</th>
                                                                <th>Desconto</th>
                                                                <th>Valor Total</th>
                                                                <th>Nome Colaborador</th>
                                                                <th>Obs</th>
                                                                <th className="text-right">Status</th>
                                                                <th className="text-right">Ações</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {agendamentos.map((agendamento, index) => (
                                                                <CardAgendamentos
                                                                    key={`${agendamento.ID_RESERVA}-${index}`}
                                                                    agendamento={{
                                                                        agendamento_id: agendamento.ID_RESERVA,
                                                                        agendamento_descricao: agendamento.DESCRICAO || 'Descrição indisponível',
                                                                        agendamento_nome: agendamento.AA_CLIENTE_NOME || 'Nome indisponível',
                                                                        agendamento_fone: agendamento.AA_CLIENTE_FONE || 'Telefone indisponível',
                                                                        agendamento_data: agendamento.DATA_RESERVA || 'Data indisponível',
                                                                        agendamento_hora: agendamento.HORA || 'Hora indisponível',
                                                                        agendamento_vr: agendamento.VALOR || 0,
                                                                        agendamento_desc: agendamento.DESCONTO || 0,
                                                                        agendamento_vrtot: agendamento.VALORTOTAL || 0,
                                                                        agendamento_nome_colaborador: agendamento.COL_NOME || 'Colaborador indisponível',
                                                                        agendamento_obs: agendamento.AA_DESCRICAO || 'Obs indisp',
                                                                        agendamento_status: `${agendamento.ID_STATUS} : ${agendamento.ST_DESCRICAO || 'Status indisponível'}`
                                                                    }}
                                                                    showOpcoes={true}
                                                                    showExcluir={false}
                                                                    showAvaliar={false}
                                                                    showMotivo={false}
                                                                    showMudarStatus={false}
                                                                    // handleExcluir={handleExcluir}
                                                                    tipoAtendimento={tipoAtendimento}
                                                                    handleOpcoes={handleOpcoes}
                                                                />
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>  {/*← ADICIONE AQUI */}
                                            </div>

                                        )}
                                    </div>
                                    {hasMore && (
                                        <div className="load-more">
                                            <button onClick={() => setPagina(prevPagina => prevPagina + 1)}>Carregar mais</button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* {console.log('id_usuario antes do cardagendamentoOpcoes ', id_usuario)} */}
            {/* Dock para as opções do botão "opções" que subsitituiu o botão "excluir" */}
            <Dock 
                position="bottom" 
                isVisible={dockOpen} 
                onVisibleChange={(visible) => setDockOpen(visible)} 
                // fluid={false}
                // size={350} // era 370 e estava ficando largo demais em celular tela pequena 26/10/24w14h55 // tamanho da tela em tamanho absoluto em pixels
                fluid={true} 
                size={isMobile ? 0.8 : 0.7} // tamanho da tela em fração de %
            >
                <CardAgendamentoOpcoes id_usuario={id_usuario} tipoAtendimento={tipoAtendimento} agendamento={selectedAgendamento} closeDock={closeDock} paginaAgendamento='p_abertos'/>
            </Dock>

            <Footer />
        </>
    );
}

export default MeusAgendamentos;